export default __webpack_public_path__ + "static/media/logo.d555ade5.svg";